export default "__VITE_ASSET__066d3569__"